import React from "react";

export default function FundamentalsDisplay({ data }) {
  if (!data) return null;

  return (
    <div style={{ marginTop: "30px", marginBottom: "30px" }}>
      <h2 style={{ fontSize: "24px", fontWeight: "600", marginBottom: "20px" }}>
        📐 Fundamentals
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))",
          gap: "15px"
        }}
      >
        {Object.entries(data).map(([key, value]) => (
          <div
            key={key}
            style={{
              padding: "15px",
              background: "white",
              borderRadius: "10px",
              border: "1px solid #e5e7eb",
              textAlign: "center"
            }}
          >
            <div style={{ fontSize: "14px", color: "#6b7280" }}>{key}</div>
            <div style={{ fontSize: "20px", fontWeight: "700", color: "#111827" }}>
              {value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
